import { API } from '@/config';

import {
  FILL_LIST,
} from './mutations-types';

export default {
  async getStepList({ commit }) {
    try {
      const { records } = (await API.get('/connections/step/getList')).data.data;
      commit(FILL_LIST, { records });
    } catch (err) {
      console.log(err);
    }
  },
};
